interface SignatureProps {
  buyerSignature?: string;
  sellerSignature?: string;
  agentSignature?: string;
  BuyersignedAt?: string;
  SellersignedAt?: string;
}

const signature = ({
  buyerSignature,
  sellerSignature,
  agentSignature,
  BuyersignedAt,
  SellersignedAt,
}: SignatureProps) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Signature
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-4">
          <h3 className="font-medium">Buyer</h3>
          <div className="border-b-2 border-gray-300 pb-1 mb-2">
            <span className="text-gray-500">
              <img
                src={buyerSignature ? buyerSignature : ''}
                alt="Buyer Signature"
              />
            </span>
          </div>
          <div className="border-b border-gray-300 pb-1">
            <span className="text-gray-500">
              {BuyersignedAt
                ? new Date(BuyersignedAt).toLocaleDateString()
                : 'N/A'}{' '}
            </span>
          </div>
        </div>
        <div className="space-y-4">
          <h3 className="font-medium">Seller</h3>
          <div className="border-b-2 border-gray-300 pb-1 mb-2">
            <span className="text-gray-500">
              <img
                src={sellerSignature ? sellerSignature : ''}
                alt="Seller Signature"
              />
            </span>
          </div>
          <div className="border-b border-gray-300 pb-1">
            <span className="text-gray-500">
              {SellersignedAt
                ? new Date(SellersignedAt).toLocaleDateString()
                : 'N/A'}{' '}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default signature;
